import isBoolean from 'foundation/js/inputValidators/isBoolean'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'

export default [
    {
        name: 'joinATeam',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        name: 'isChild',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        dependentField: 'joinATeam',
        dependentFieldValue: false,
        dependentFieldValidator: (value) => value === false,
        name: 'teamName',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'newsletter',
        value: false,
        isValid: false,
        validator: isBoolean
    }
]
